import React, { useState, createContext, useContext } from "react";
import { useAxios } from "../../hooks/useAxios";

export const AutheContext = createContext();
export const AuthContext = () => useContext(AutheContext);

export const Auth = (props) => {
  const [logIn, setLogIn] = useState(localStorage.getItem("token") || null);
  const [user, setUser] = useState(null);
  const { request } = useAxios();
  // console.log(logIn);
  let register = (state, callback) => {
    request({
      url: "/public/auth/register",
      method: "post",
      body: state,
      includeToken: false,
    })
      .then((res) => {
        alert(res?.data?.success);
        callback();
      })
      .catch((error) => {
        return error;
      });
  };

  let login = (state, callback) => {
    request({
      url: "/public/auth/login",
      method: "post",
      body: state,
      includeToken: false,
    })
      .then((res) => {
        if (res?.data?.success) {
          localStorage.setItem("token", res?.data?.data);
          setLogIn(res?.data?.data);
          callback();
        }
      })
      .catch((err) => {
        // console.log(err);
        setLogIn(null);

        return err;
      });
  };

  let value = { user, logIn, register, login };

  return (
    <AutheContext.Provider value={value}>
      {props?.children}
    </AutheContext.Provider>
  );
};

export default Auth;
